
import { MapLocation } from '@/types/location';

// LoCa Studios Gym Locations
export const locaStudiosGyms: MapLocation[] = [
  {
    id: 8001,
    name: "LoCa Studios Gym - Jeddah (Al Mohamdia)",
    type: "Gym",
    devices: 5,
    coordinates: [21.636416296821935, 39.12678893558234],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
